export var MPXVideoProperty;
(function (MPXVideoProperty) {
    MPXVideoProperty["AA_ORIGINAL"] = "AA Original";
    MPXVideoProperty["BBLF"] = "BBLF";
    MPXVideoProperty["BRANDED"] = "Branded";
    MPXVideoProperty["CLIP"] = "Clip";
    MPXVideoProperty["DAI_LIVE_STREAM"] = "DAI Live Stream";
    MPXVideoProperty["DVR"] = "DVR";
    MPXVideoProperty["EPISODELESS"] = "Episodeless";
    MPXVideoProperty["FRANCHISE_STANDALONE"] = "Franchise Standalone";
    MPXVideoProperty["FULL_EPISODE"] = "Full Episode";
    MPXVideoProperty["HLS_AES_LIVE_STREAM"] = "HLS AES Live Stream";
    MPXVideoProperty["KIDS"] = "Kids";
    MPXVideoProperty["LEGACY_BITRATE_LIMIT"] = "Legacy Bitrate Limit";
    MPXVideoProperty["LINEAR_AD_TRACKING_PLUGIN"] = "Linear Ad Tracking Plugin";
    MPXVideoProperty["NO_AIR"] = "No-Air";
    MPXVideoProperty["OPEN_ENDED"] = "Open-Ended";
    MPXVideoProperty["PREMIUM"] = "Premium";
    MPXVideoProperty["PROMO_FULL_EPISODE"] = "Promo Full Episode";
    MPXVideoProperty["SEASONLESS"] = "Seasonless";
    MPXVideoProperty["SEGMENT"] = "Segment";
    MPXVideoProperty["SERIES_STANDALONE"] = "Series Standalone";
    MPXVideoProperty["START_OVER"] = "Startover";
})(MPXVideoProperty || (MPXVideoProperty = {}));
